import { render, staticRenderFns } from "./JybeButton.vue?vue&type=template&id=673d2ea2&"
import script from "./JybeButton.vue?vue&type=script&lang=js&"
export * from "./JybeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports